













































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
// import { firstDayInPrevMonth, formatDateTime } from "@/global.ts";
import GlobalMixins from "@/global.mixin.ts";

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class Locations extends Vue {
  @State("locations") locationsState: any;

  @Action("getLocations") getLocations: any;
  @Action("saveLocation") saveLocation: any;
  @Action("deleteLocation") deleteLocation: any;

  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";

  editingDialog = false;
  isNewLocation = false;
  defaultItem = {
    locationId: 0,
    name: "",
    isInUse: false,
  };
  editedItem = Object.assign({}, this.defaultItem);
  editedIndex = -1;
  dollySearchTerm = "";
  localDollies = [];

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "name",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("locations-rowsPerPage") ?
                        parseInt(this.$cookies.get("locations-rowsPerPage"), 10) : 25
  };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  // tslint:disable:max-line-length
  getHeaders() { return [
    { text: "#", value: "locationId", width: "1%", align: "left", sortable: true},
    { text: this.$t("LOCATIONS_TABLE_HEADER_NAME"), value: "name", width: "1%", align: "left", sortable: true },
    { text: this.$t("TABLE_ACTIONS"), value: "", sortable: false,  }
  ];
  }
  created() {
    // -
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column, sortable) {
    if (!sortable) {
      return;
    }

    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("locations-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getLocations(page);
  }

  save() {
    this.saveLocation({
      data: JSON.stringify(this.editedItem),
      index: this.editedIndex
    })
      .then(res => {
        this.close();
      })
      .catch(res => {
        // handle....
        // this.close();
      });
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
  }

  editItem(item) {
    this.isNewLocation = false;
    this.editedIndex = this.locationsState.locations.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.editingDialog = true;
  }

  deleteItem(item) {
    const index = this.locationsState.locations.indexOf(item);

    if (confirm("Are you sure to delete the Location?")) {
      this.deleteLocation({ id: item.locationId, index });
    }
  }
}
